<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <branch-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-create>
</template>

<script>

import BranchProvider from "../../../../providers/BranchProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import BranchForm from "../BranchForm";


export default {
  name: "BranchCreate",

  components: {BranchForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'delivery.branch.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        name: '',
        role: '',
        location: {
          localityFilter: null,
          address: '',
          floor: '',
          apartment: '',
          latitude: null,
          longitude: null,
          country: '',
          province: '',
          locality: '',
          postalCode: ''
        },
        isDefault: false
      }
    }
  },

  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        BranchProvider.createBranch(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createBranch)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }

  },
}
</script>

<style scoped>

</style>

